import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { obtenerDatosHotel } from '../services/motorService';
import Cookies from 'js-cookie';

export default function Rules() {

  const [datosHotel, setDatosHotel] = useState({});
  const hotCod = Cookies.get('hotCod');
  useEffect(() => {
    const getData = async () => {
      try {
        const data = await obtenerDatosHotel(hotCod);
        setDatosHotel(data);
      } catch (error) {
        console.error('Error fetching hotel data:', error);
      }
    };
    getData();
  }, []); // Lista de dependencias vacía para que se ejecute solo una vez
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="h5" component="div" sx={{ mb: 2 }}>
        Normas de {datosHotel.MotorHotNombre}
      </Typography>
      <Card sx={{ minWidth: 275 }}>
        <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Typography sx={{ fontSize: 16 }} color="text.secondary" component="div">
            {datosHotel.MotorHotNormas || 'El hotel no tiene infomracón disponible'}
          </Typography>

        </CardContent>
      </Card>

    </Box>
  );
}